import {
  ActionButton,
  OfficeHeader,
  Show,
  TableComponent,
  TableLoader,
} from "components";
import { FC } from "react";
import { useMatch, useNavigate, useSearch } from "react-location";

import { Action } from "components/buttons/action-button";
import { LocationGenerics } from "router/location";
import OfferTransactionThreadContainer from "pages/view-offer/components/offer-transaction-thread";
import SendEmailsContainer from "./send";
import ViewNoteContainer from "./view";
import numeral from "numeral";
import { useOffer } from "hooks/data/use-offers";
import { useUpdateBubble } from "hooks/data/use-update-bubble";
import { useUrlState, withPermissions } from "utils";

type Props = {};

const CreditNotesPage: FC<Props> = () => {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useSearch<LocationGenerics>();
  const [modal, setModal] = useUrlState("modal");
  const navigate = useNavigate<LocationGenerics>();
  const { updateBubble } = useUpdateBubble();

  const { loading, offer, refetch } = useOffer({
    offer_id: params?.offer || "",
  });

  const updateThreadBubble = (ids: string[]) => {
    updateBubble({
      variables: {
        ids,
      },
    })
      .then(() => {})
      .catch((err) => {});
  };

  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
    () => {
      navigate({
        search: (old) => ({
          ...old,
          id,
          modal: action,
        }),
      });
    };

  return (
    <div>
      <OfficeHeader />

      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            loading={loading}
            title={"credit notes"}
            columns={[
              {
                name: "Company Name",
                accessor: "reinsurer.re_company_name",
              },
              {
                name: "Company Email",
                accessor: "reinsurer.re_company_email",
              },
              {
                name: "Reinsurer Amount",
                accessor: "offer_amount",
                render: (value) => (
                  <>
                    {offer?.offer_detail?.currency}{" "}
                    {numeral(value?.offer_amount).format("0,0.00")}
                  </>
                ),
              },
              {
                name: "Participant %",
                accessor: "offer_participant_percentage",
              },
              {
                name: "Action",
                accessor: "actions",
                render: (value) => (
                  <>
                    <ActionButton
                      action={"clone"}
                      tooltip="Generate Closing Docs"
                      onClick={dispatchAction(
                        value?.offer_participant_id || "",
                        "view"
                      )}
                    />
                    <Show
                      if={
                        Boolean(offer?.version !== "V2") &&
                        Boolean(offer?.offer_from === "INTERNAL")
                      }
                    >
                      {withPermissions([
                        "*:*",
                        "offers:*",
                        "offers:manage",
                        "offers:send",
                      ])(
                        <ActionButton
                          action={"send"}
                          onClick={dispatchAction(
                            value?.reinsurer?.reinsurer_id || "",
                            "send"
                          )}
                        />
                      )}
                    </Show>
                    <Show
                      if={Boolean(
                        value?.offer_published_participant
                          ?.offer_published_participant_id
                      )}
                    >
                      <ActionButton
                        action="chat"
                        tooltip="View Message Thread"
                        onClick={() => {
                          navigate({
                            search: (old) => ({
                              ...old,
                              id: value?.offer_published_participant
                                ?.offer_published_participant_id,
                              modal: "chat",
                              reinsurer: value?.reinsurer?.re_company_name,
                              offer: offer?.place_it_id || "",
                            }),
                          });
                        }}
                        count={0}
                        callBack={() =>
                          updateThreadBubble(
                            value.thread_notification?.map(
                              (item: any) => item?.id || ""
                            ) || []
                          )
                        }
                      />
                    </Show>
                  </>
                ),
              },
            ]}
            data={offer?.offer_participant || []}
            renderLoader={() => <TableLoader items={[1, 1, 1, 1, 1]} />}
            refetch={refetch}
          />
        </div>
      </div>

      {searchParams.id && modal === "view" && (
        <ViewNoteContainer
          open={modal === "view"}
          setOpen={(val: boolean) => setModal(val ? "view" : undefined)}
        />
      )}

      {searchParams.id && modal === "send" && (
        <SendEmailsContainer
          open={modal === "send"}
          setOpen={(val: boolean) => setModal(val ? "send" : undefined)}
        />
      )}
      {searchParams.id && modal === "chat" && (
        <OfferTransactionThreadContainer
          open={modal === "chat"}
          setOpen={(val: boolean) => setModal(val ? "chat" : undefined)}
        />
      )}
    </div>
  );
};

export default CreditNotesPage;
